module.exports = __webpack_public_path__ + "static/media/videos.f0b5fa91.svg";